export default {
  methods: {
    checkValidation (customMessage, listOfOtherVObjects) {
      this.$v.$touch()
      var invalid = this.$v.$invalid
      if (listOfOtherVObjects) {
        listOfOtherVObjects.forEach(v => {
          if (v) {
            v.$touch()
            if (!invalid) {
              invalid = v.$invalid
            }
          }
        })
      }

      if (invalid) {
        return false
      }
      return true
    }
  }
}
